import { useState } from 'react';

import { ChatComposer } from '@/modules/hiring-manager/chat/chatComposer/ChatComposer';
import { ChatExamples } from '@/modules/hiring-manager/chat/chatExamples/ChatExamples';
import { useNewChat } from '@/modules/hiring-manager/chat/useNewChat';

import { ChatScreen } from './ChatScreen';

/** `/hm/chat`: a chat not started yet. The first message opens the chat on its own page at once. */
export function NewChat() {
  const openNewChat = useNewChat();
  const [example, setExample] = useState({ key: 0, prompt: '' });

  return (
    <ChatScreen
      footer={
        <ChatComposer
          busy={false}
          defaultValue={example.prompt}
          key={example.key}
          onSend={(text) => openNewChat(text)}
        />
      }
    >
      <div className="flex flex-col gap-4 pt-[12vh]">
        <h1 className="text-[24px] leading-8 font-semibold tracking-[-0.02em]">
          What can I do for you?
        </h1>
        <p className="text-muted-foreground">
          Describe a job or paste its description, and I&apos;ll set it up with
          you. You can also finish a draft or change a job.
        </p>
        <ChatExamples
          onPick={(prompt) =>
            setExample((current) => ({ key: current.key + 1, prompt }))
          }
        />
      </div>
    </ChatScreen>
  );
}
